import React from 'react'
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

export default function Footer() {
    return (
        <footer style={{ backgroundColor: "#fafafa", marginTop: "0px", padding: "10px 0px" }}>
        <Grid container justifyContent="center" style={{ width: "100%",  }}>
            <Grid alignItems="center" xs={12} item container style={{ maxWidth: '1344px', padding: "10px", minWidth: '340px' }}>                            
                <Grid justifyContent="flex-end" xs={6} sm={6}  md={6} item>                        
                    <Typography align="left" style={{height: "20px", fontFamily: 'BlinkMacSystemFont'}}>
                        © Copyright&nbsp; 
                        
                        <span style={{height: "20px", fontWeight: 900}}>
                        Yonghui Liu
                        </span>
                    </Typography>                    
                </Grid>
                <Grid justifyContent="flex-end" xs={6} sm={6}  md={6} item>                        
                    <Typography align="right" style={{height: "20px"}}>
                        updated on Apr, 2025
                    </Typography>
                </Grid>
            </Grid>
            </Grid>
        </footer>
    )
}
